"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const react_1 = require("react");
const usehooks_ts_1 = require("usehooks-ts");
const components_1 = require("components");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
const inline_colors_1 = require("inline-colors");
const components_2 = require("../../new_deal/components");
const checkLocations_1 = require("./utils/checkLocations");
const AppModalHeader = ({ handleClose }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "app-modal-header flex space-between", children: [(0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Patient_Financing_Logo_png_1.default, alt: "Alphaeon Credit" }), (0, jsx_runtime_1.jsx)("div", { className: "close-button-container", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(Close_1.default, { className: "close-button", htmlColor: inline_colors_1.INLINE_COLORS.blackBase, "data-testid": "modal-close-button" }) }) })] }));
};
const AppModals = ({ allLocations, currentLocation, }) => {
    // Hooks
    const [sessionValue, setSessionValue] = (0, usehooks_ts_1.useSessionStorage)('displayAppModal', 'true');
    // Vars
    // State
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(null);
    const [showNonSignerBanner, setShowNonSignerBanner] = (0, react_1.useState)(false);
    const [showNoAuthSignerBanner, setShowNoAuthSignerBanner] = (0, react_1.useState)(false);
    const handleBtnClose = () => {
        setIsModalOpen(false);
    };
    const handleClose = (event, reason) => {
        if (reason && reason === 'backdropClick')
            setIsModalOpen(false);
    };
    (0, react_1.useEffect)(() => {
        if (showNonSignerBanner || showNoAuthSignerBanner) {
            if (sessionValue !== 'false') {
                setIsModalOpen(true);
            }
        }
    }, [showNonSignerBanner, showNoAuthSignerBanner]);
    (0, react_1.useEffect)(() => {
        const { noSignersBanner, nonSignerBanner } = (0, checkLocations_1.checkLocations)(allLocations, currentLocation);
        setShowNoAuthSignerBanner(noSignersBanner);
        setShowNonSignerBanner(nonSignerBanner);
    }, [allLocations, currentLocation]);
    (0, react_1.useEffect)(() => {
        if (isModalOpen === false) {
            setSessionValue('false');
        }
    }, [isModalOpen]);
    const isNewDealTurnedOnForThisLocation = (0, react_1.useCallback)(() => {
        return (allLocations.filter((itm) => itm.metadata && itm.metadata != null)
            .length > 0);
    }, [allLocations]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isNewDealTurnedOnForThisLocation() ? ((0, jsx_runtime_1.jsx)(core_1.Modal, { keepMounted: false, open: !!isModalOpen, onClose: handleClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", children: (0, jsx_runtime_1.jsxs)("div", { className: "vh100 bg-white overflow-scroll", children: [(0, jsx_runtime_1.jsx)(AppModalHeader, { handleClose: handleBtnClose }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center flex-dir-col", children: currentLocation ? ((0, jsx_runtime_1.jsx)(components_2.VerifyBusinessInfo, { handleClose: handleBtnClose, showNonSignerBanner: showNonSignerBanner, showNoAuthSignerBanner: showNoAuthSignerBanner, currentLocation: currentLocation })) : null })] }) })) : null }));
};
exports.default = AppModals;
